import React from 'react';
import {
	Toast,
	ToastHeader,
	ToastImg,
	ToastInnerContainer,
	ToastTextContainer,
	ToastTitle,
} from '../../../../TrailPage/Navigate/Toast/toastStyles';
import { Place } from '../../../../../models/Place';
import { checkImage } from '../../../../componentUtils';
import { useAppSelector } from '../../../../../state/hooks';
import { RootState } from '../../../../../state/store';
import { shallowEqual } from 'react-redux';
import LoadingImage from '../../../LoadingImage/LoadingImage';
import { PlaceHelper } from '../../../../../models/helpers/Helpers';
import { useHistory } from 'react-router';

type SingleToastProps = {
	margin?: string;
	place: Place;
};
const SingleToast: React.FC<SingleToastProps> = ({ margin, place }) => {
	const history = useHistory();
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);

	const gotoPlacePage = () => {
		history.push('/place/' + place.id);
	};

	return (
		<Toast
			margin={margin}
			onClick={() => {
				gotoPlacePage();
			}}>
			<ToastInnerContainer>
				{network_status && (
					<ToastImg>
						<LoadingImage src={checkImage(place.image)} />
					</ToastImg>
				)}
				<ToastTextContainer className={network_status ? '' : 'offline'}>
					<ToastTitle>{place.title}</ToastTitle>
					<ToastHeader>
						{PlaceHelper.generateMetaString(place)}
					</ToastHeader>
					{/* <ToastCaption>
						A Toast is a subtle notification commonly used in modern
						applications. It can be used to provide feedback about
						an operation or to display a system message.
					</ToastCaption> */}
				</ToastTextContainer>
			</ToastInnerContainer>
		</Toast>
	);
};

export default SingleToast;
